var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as APTypes from './types';
import { Contracts, Utils } from './apis';
export class AP {
    constructor(web3, contracts) {
        this.utils = Utils;
        this.web3 = web3;
        this.contracts = contracts;
    }
    /**
     * Returns a new AP instance.
     * @param {Web3} web3 Web3 instance
     * @param {AddressBook} addressBook object containing addresses for ap-contracts
     * @returns {Promise<AP>}
     */
    static init(web3, addressBook) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!(yield web3.eth.net.isListening())) {
                throw (new Error('Could not establish connection to Ethereum node.'));
            }
            const contracts = new Contracts(web3, addressBook);
            return new AP(web3, contracts);
        });
    }
}
export { Utils, APTypes };
//# sourceMappingURL=index.js.map